import React from "react";
import PaidAndBookedEvents from '../../components/User/PaidAndBookedEvents';
import RestUtilities, { IRestResponse } from '../../services/RestUtilities';
import BookedEventsModel from '../../models/BookedEvents'
import PaymentTypes from '../../models/PaymentTypes'
import { Snackbar } from '@mui/material';
import SnackbarWrapper from '../../components/SnackbarWrapper';
import Auth from '../../stores/Auth';
import Loader from '../../components/Loader'
import { GrowMessage } from "../../components/GrowMessage";

export class FilterModel {
    eventName: string = ''
    bookingDateFrom: Date = null
    bookingDateTo: Date = null
    paymentTypeId: number
    [key: string]: any
}

class BookedEvents extends React.Component<any, any> {

    state = {
        bookedEvents: [] as BookedEvents[],
        paymentTypes: [] as PaymentTypes[],
        filter: new FilterModel(),
        showError: false,
        errorMessage: '',
        loading: false
    }

    handleChangeFilter = (event: any): void => {
        const newFilter = {...this.state.filter}
        const fieldName = event.target.name

        newFilter[fieldName] = event.target.value

        this.setState({ filter: newFilter })
    }

    handleFilterEvents = (): void => {
        this.fetchBookedEvents(this.state.filter.eventName, 
            this.state.filter.bookingDateFrom, 
            this.state.filter.bookingDateTo, 
            this.state.filter.paymentTypeId)
    }

    handleClearFilter = (): void => {
        this.setState({ filter: new FilterModel() })
        this.fetchBookedEvents()
    }

    fetchPaymentTypes = (): void => {
        RestUtilities.get<PaymentTypes[]>('/api/PaymentTypes')
            .then(resp => {
                this.setState({ paymentTypes: resp.content })
            }).catch(resp => {
                this.showError(resp)
            })
    }

    fetchBookedEvents = (eventName: string = '', 
                        bookingDateFrom: Date = null,
                        bookingDateTo: Date = null, 
                        paymentTypeId: number = null): void => {

        this.setState({ loading: true })

        let personalNr = Auth.getPersonalNr()
        let url = `/api/ListBookedEvents?personalNr=${personalNr}&`
        
        if(eventName !== '')
            url += `eventName=${eventName}&`
        if(bookingDateFrom !== null) {
            let date = new Date(bookingDateFrom)
            let dateString = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
            url += `dateFrom=${dateString}&`
        }
        if(bookingDateTo !== null) {
            let date = new Date(bookingDateTo)
            let dateString = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
            url += `dateTo=${dateString}&`
        }
        if(paymentTypeId !== null)
            url += `paymentTypeId=${paymentTypeId}&`

        RestUtilities.get<BookedEventsModel[]>(url)
            .then(resp => {
                this.setState({ bookedEvents: resp.content, loading: false })
            }).catch(resp => {
                this.showError(resp)
            })
    }

    showError = (resp: IRestResponse<BookedEventsModel>): void => {
        if(typeof resp.error_content != 'undefined' && resp.error_content) {
            this.setState({ showError: true, errorMessage: resp.error_content, loading: false })
        }
    }

    handleSnackbarClose = (event: any, reason: string) => {
        if (reason === 'clickaway')
            return;

        this.setState({ showError:false })
    }

    componentDidMount() {
        this.fetchBookedEvents()
        this.fetchPaymentTypes()
    }

    public render() {

        return (
            <>
                <h2 className='title'>Gebuchte Veranstaltungen</h2>

                <PaidAndBookedEvents
                    events={this.state.bookedEvents}
                    paymentTypes={this.state.paymentTypes}
                    filter={this.state.filter}
                    filterChange={this.handleChangeFilter}
                    handleFilter={this.handleFilterEvents}
                    clearFilters={this.handleClearFilter} />
                <GrowMessage
                    anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                    }}
                    message={this.state.errorMessage}
                    visible={this.state.showError}
                    autoHideDuration={6000}
                    onClose={this.handleSnackbarClose} ></GrowMessage>  
                {/* <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={this.state.showError}
                    autoHideDuration={6000}
                    onClose={this.handleSnackbarClose}
                >
                    <SnackbarWrapper
                        onClose={this.handleSnackbarClose}
                        variant="success"
                        message={this.state.errorMessage}
                    />
                </Snackbar> */}
                {this.state.loading && <Loader />}
            </>
        )
    }
}

export default BookedEvents